export async function encryptAESBase64(
  stringText: string,
  encodedKey: string,
  encodedIv: string
) {
  const key = await window.crypto.subtle.importKey(
    "raw",
    base64ToArrayBuffer(encodedKey),
    {
      name: "AES-GCM",
      length: 128,
    },
    true,
    ["encrypt", "decrypt"]
  );
  const cypherText = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: base64ToArrayBuffer(encodedIv),
    },
    key,
    stringToArrayBuffer(stringText)
  );
  return arrayBufferToBase64(cypherText);
}
export function stringToArrayBuffer(inputString: string): ArrayBuffer {
  const encoder = new TextEncoder();
  return encoder.encode(inputString).buffer;
}
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const uint8Array = new Uint8Array(buffer);
  const binaryString = uint8Array.reduce(
    (acc, byte) => acc + String.fromCharCode(byte),
    ""
  );
  return btoa(binaryString);
}
export function base64ToArrayBuffer(base64String: string): ArrayBuffer {
  const binaryString = atob(base64String);
  const length = binaryString.length;
  const arrayBuffer = new ArrayBuffer(length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  return arrayBuffer;
}
